import React, { useState } from "react";
import SampleDashboardLayout from "./SampleDashboardLayout";

import Subscription from "../../../components/Subscription/Subscription";
import { useSelector } from "react-redux";

const SampleSubscripiton = () => {
    const user = useSelector((state) => state.AuthSlice.user);

    return (
        <>
            <SampleDashboardLayout>
                <Subscription role={user?.role?.name} />
            </SampleDashboardLayout>
        </>
    );
};

export default SampleSubscripiton;
